module.exports = __webpack_public_path__ + "assets/ba93ec0c94332436e7e16b0850cc619d.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/Background.mp3
 ** module id = 216
 ** module chunks = 0
 **/